const STYLE = {
  dead: { cls: 'border-red-500 text-red-500', glow: 'rgba(239,68,68,0.6)', label: 'LOST' },
  won: { cls: 'border-emerald-400 text-emerald-400', glow: 'rgba(52,211,153,0.6)', label: 'WON' },
};

export default function DeadStamp({ ticketId, big = false, variant = 'dead' }) {
  const s = STYLE[variant];
  return (
    <div className={`pointer-events-none absolute inset-x-0 top-0 flex justify-end z-10 ${big ? 'pr-16 pt-12' : 'pr-3 pt-24'}`} data-testid={`${variant}-stamp-${ticketId}`}>
      <span className={`-rotate-12 border-[3px] ${s.cls} font-black tracking-[0.2em] rounded-md bg-black/70 ${big ? 'text-2xl px-3 py-0.5' : 'text-sm px-1.5'}`}
        style={{ textShadow: `0 0 8px ${s.glow}` }}>
        {s.label}
      </span>
    </div>
  );
}
